import type { install as installEn } from '../en/install';

export const install: typeof installEn = {
  title: 'Agregue First Weeks a su pantalla de inicio',
  body: 'Se abre con un toque, funciona sin señal y su registro se guarda de forma segura en este teléfono.',
  bodyIos:
    'Se abre con un toque y funciona sin señal. En el iPhone, esto también evita que Safari borre su registro si pasa una semana sin abrirlo.',
  addButton: 'Agregar a la pantalla de inicio',
  installing: 'Agregando…',

  step1Before: 'Toque el',
  optionsLabel: 'menú de opciones',
  step1After: 'en la barra de direcciones',
  step2Before: 'Elija',
  shareLabel: 'Compartir',
  step3Before: 'Elija',
  addToHomeScreen: 'Agregar a inicio',

  finePrint:
    'Al agregarla así, la instala directamente desde su pediatra, sin tienda de aplicaciones y sin crear una cuenta. No se descarga nada a través de Apple ni de Google, así que ninguna tienda tiene registro de ello, y su registro sigue siendo suyo, en su propio teléfono, en lugar de estar guardado en la cuenta de alguna empresa.',
};
